import type { GadgetData } from '@atlassian/jira-dashboard-common/src/types.tsx';

export const lensGadgetsList =
	<
		T extends {
			gadgets: GadgetData[];
		} | null,
	>(
		updateGadgets: (arg1: GadgetData[]) => GadgetData[],
	): ((arg1: T) => T) =>
	(config: T) =>
		config && {
			...config,
			gadgets: updateGadgets(config.gadgets),
		};

export const lensGadget = <
	T extends {
		gadgets: GadgetData[];
	} | null,
>(
	id: string,
	setterOrValue: Partial<GadgetData> | ((arg1: GadgetData) => Partial<GadgetData>),
): ((arg1: T) => T) => {
	const setter: (arg1: GadgetData) => Partial<GadgetData> =
		typeof setterOrValue === 'function' ? setterOrValue : () => setterOrValue;

	return lensGadgetsList((gadgets) =>
		gadgets.map((item) => (item.id === id ? { ...item, ...setter(item) } : item)),
	);
};
